module.exports = __webpack_public_path__ + "img/134.c49b7be9.jpg";